import { EmphasizeMatchingText } from 'components/shared/EmphasizeMatchingText/EmphasizeMatchingText';
import type { ForexUnderlying } from 'models/underlying/forex';
import { FC, useContext } from 'react';

import { InputTextContext, StyledNameTD } from '../Common';

export const ForexMenuOption: FC<ForexUnderlying> = ({ name }) => {
  const inputText = useContext(InputTextContext);

  return (
    <>
      <StyledNameTD>
        <span data-e2e={`multi-underlying-selector-option-name-${name}`}>
          <EmphasizeMatchingText searchText={inputText}>{name}</EmphasizeMatchingText>
        </span>
      </StyledNameTD>
    </>
  );
};
